export const MAILCHIMP = 'MAILCHIMP'
export const WORKFLOWMAX = 'WORKFLOWMAX'
export const SLACK = 'SLACK'
export const MINDBODY = 'MINDBODY'
